export default "__VITE_ASSET__B_6k8pwZ__"